module.exports = __webpack_public_path__ + "static/img/logo.4e2308b4.svg";